import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { environment } from '@se-po/shared-environments'
import { SeAnalyticsModule } from 'se-analytics'
import { SeFeApiModule } from 'se-fe-api'
import { SeFeAuthSupportModule } from 'se-fe-auth-support'
import { SeFeTranslationsModule } from 'se-fe-translations'

import { WINDOW } from 'se-fe-domain-environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CreateAccountModule } from './create-account/create-account.module'
import { CreateHouseholdModule } from './create-household/create-household.module'
import { MinorAccountModule } from './minor-account/minor-account.module'
import { SetupMembershipModule } from './setup-membership/setup-membership.module'

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CreateAccountModule,
    CreateHouseholdModule,
    HttpClientModule,
    MinorAccountModule,
    SeAnalyticsModule.forRoot({
      platProp: 'user_service',
      platformSubSec: 'SingleSignOn',
      currentEnv: environment.name,
    }),
    SeFeApiModule.forRoot({
      domainEnvironments: environment.domainEnvironments,
    }),
    SeFeAuthSupportModule.forRoot(environment),
    SeFeTranslationsModule.forRoot(['en', 'en-gb'], environment.local ? '/setup' :  `${environment.baseUrl}/se-household-setup`),
    SetupMembershipModule,
  ],
  providers: [{ provide: WINDOW, useValue: window }],
  bootstrap: [
    AppComponent
  ],
  exports: [],
})
export class AppModule { }
